module.exports = __webpack_public_path__ + "img/background.9db8dd4e.png";